module.exports = __webpack_public_path__ + "img/slide4.f65e232a.jpg";